module.exports = __webpack_public_path__ + "img/intro text_uk.516cb1a9.svg";